import { all, put, select, takeLatest } from 'redux-saga/effects';
import { actionCreator } from './slice';
import { handleSagaError } from '../common/saga';
import { ISendGridTemplate } from '@/models/templates';
import { messageFactory } from '../messaging';
import { api } from '@/api/controllers/api';
import { selectors } from '.';

export function* saga() {
	yield takeLatest(actionCreator.INIT_EMAIL_START, initEmailStart);
	yield takeLatest(
		actionCreator.LOAD_SOURCE_EMAIL_TEMPLATE_START,
		loadSourceEmaileTemplateStart
	);
	yield takeLatest(
		actionCreator.LOAD_TARGET_EMAIL_TEMPLATE_START,
		loadTargetEmailTemplateStart
	);
	yield takeLatest(
		actionCreator.REPLICATE_EMAIL_TEMPLATE_START,
		replicateEmailTemplateStart
	);
}

function* initEmailStart() {
	try {
		yield put(messageFactory.progress('Loading Email Templates...'));
		const response: ISendGridTemplate[] =
			yield api.templates.getSendGridTemplates();
		yield put(actionCreator.INIT_EMAIL_COMPLETED(response));
	} catch (error) {
		yield handleSagaError(error, [actionCreator.INIT_EMAIL_FAILED()]);
	} finally {
		yield put(messageFactory.dismissProgress());
	}
}

function* loadSourceEmaileTemplateStart() {
	try {
		const source: ISendGridTemplate = yield select(
			selectors.getSourceEmailTemplate
		);

		const response: ISendGridTemplate =
			yield api.templates.getSendGridTemplate({ id: source.id });

		yield all([
			put(actionCreator.LOAD_SOURCE_EMAIL_TEMPLATE_COMPLETED(response)),
			put(actionCreator.UPDATE_EMAIL_TEMPLATE(response))
		]);
	} catch (error) {
		yield handleSagaError(error, [
			actionCreator.LOAD_SOURCE_EMAIL_TEMPLATE_FAILED()
		]);
	}
}

function* loadTargetEmailTemplateStart() {
	try {
		yield put(messageFactory.progress('Loading Target Email Template...'));
		const sourceTemplate: ISendGridTemplate = yield select(
			selectors.getSourceEmailTemplate
		);
		const targetEnvironment: string = yield select(
			selectors.getTargetEmailTemplateEnvironment
		);
		const response: ISendGridTemplate =
			yield api.templates.getSendGridTemplateByName({
				environment: targetEnvironment,
				name: sourceTemplate.name
			});
		yield put(actionCreator.LOAD_TARGET_EMAIL_TEMPLATE_COMPLETED(response));
	} catch (error) {
		yield handleSagaError(error, [
			actionCreator.LOAD_TARGET_EMAIL_TEMPLATE_FAILED()
		]);
	} finally {
		yield put(messageFactory.dismissProgress());
	}
}

function* replicateEmailTemplateStart() {
	try {
		const sourceTemplate: ISendGridTemplate = yield select(
			selectors.getSourceEmailTemplate
		);
		const targetEnvironment: string = yield select(
			selectors.getTargetEmailTemplateEnvironment
		);
		const targetTemplate: ISendGridTemplate = yield select(
			selectors.targetEmailTemplate.getData
		);

		yield api.templates.postReplicateSendGridTemplate({
			sourceTemplateId: sourceTemplate.id,
			targetEnvironment: targetEnvironment,
			targetTemplateId: targetTemplate.id
		});

		const response: ISendGridTemplate =
			yield api.templates.getSendGridTemplate({
				id: targetTemplate.id,
				environment: targetEnvironment
			});

		yield put(actionCreator.REPLICATE_EMAIL_TEMPLATE_COMPLETED(response));
	} catch (error) {
		yield handleSagaError(error, [
			actionCreator.REPLICATE_EMAIL_TEMPLATE_FAILED()
		]);
	}
}
